import { Alert, Flex, Spin } from 'antd';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { resolveError } from 'lib/utils/formatters/error/resolve-error';
import { PropsWithChildren } from 'react';
import useSearchParams from '../../../../lib/hooks/use-searchParams';
import { useValidateOnboardingTokenQuery } from './_hooks/useValidateOnboardingTokenQuery';

export function ClinicOnboardingLayout(props: PropsWithChildren<any>) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const query = useValidateOnboardingTokenQuery(token);

  if (token === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <Alert
          message="Error"
          description={'No token is set'}
          type="error"
          showIcon
        />
      </div>
    );
  }
  if (query.isLoading) {
    return (
      <Flex
        vertical
        gap={16}
        align="center"
        justify="center"
        style={{ height: '100vh' }}
      >
        <Spin size="large" />
        Validating request...
      </Flex>
    );
  }

  if (query.isError) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <ErrorDisplay
          title="Invalid onboarding token"
          description={`The token '${token}' is invalid.`}
          error={resolveError(query.error)}
        />
      </div>
    );
  }

  if (!query.data?.valid) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <ErrorDisplay
          title="Invalid onboarding token"
          description={`The token '${token}' is invalid.`}
          error={{ message: `The token '${token}' is invalid.` }}
        />
      </div>
    );
  }

  return props.children;
}
